

import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import axios from './tools/axios'
import Icon from 'vue-svg-icon/Icon.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import { shipMapping, roleList, stepOptions, thingsStatusList,
valuationList, needDonateDealStatusMap } from './tools/constant'
import { getSmartDate } from './tools/datetime'
import Elapsed from 'elapsed'
import SocialSharing from 'vue-social-sharing'
import {smartImagePath} from '@/tools/ObjectHelper'
import { dateStandard } from '@/tools/datetime'
import FastClick from 'fastclick'
import VueLoading from '@/plugin/loading'
import CHeader from '@/components/CHeader'
import gallery from './components/public/img-vuer/gallery'
import videoPlayerPlugin from '@/components/public/video-player/player'
import VueLazyload from 'vue-lazyload'
import Navigation from 'vue-navigation'
import VueAnalytics from './plugin/ga'
import {VueMasonryPlugin} from 'vue-masonry'
import defaultGift from '@/assets/icon/img-default-gift.png'
import AnnualReport from '@/plugin/annualReport'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import './responsive.css' 

import VueCompositionAPI from '@vue/composition-api'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'




Vue.use(VueCompositionAPI)


Vue.use(BootstrapVue)

Vue.use(IconsPlugin)

if (process.env.NODE_ENV === 'production') {
const bugsnagClient = bugsnag('09be5e9ae844418fd51af2495a868e63')
bugsnagClient.use(bugsnagVue, Vue)
}

Vue.use(VueAnalytics, {
appName: 'Give543',
trackingId: (location.href.indexOf('m.give543.com') !== -1 ||
location.href.indexOf('m.give-circle.com') !== -1) ? 'G-ZRZP5CHW1M' : 'G-K007S5GLP0',
vueRouter: router,
logDebug: false
})

Vue.use(VueLazyload, {
error: defaultGift,
attempt: 2,
filter: {
cdn (listener, options) {
if (/s3-ap-southeast-1.amazonaws.com/.test(listener.src)) {
listener.src = smartImagePath(listener.src, listener.el.dataset.type === 'small', listener.el.dataset.type === 'origin')
}
}
}
})
Vue.use(ToastPlugin, { position: 'bottom', time: 5000 })
Vue.use(VueLoading)
Vue.use(gallery)
Vue.use(VueMasonryPlugin)
Vue.use(videoPlayerPlugin)
Vue.use(AnnualReport, {
router
})

FastClick.prototype.onTouchEnd = (event) => {
if (event.target.hasAttribute('type') &&
event.target.getAttribute('type') === 'file') {
return false
}
}

const veeValidateConfig = {
errorBagName: 'errorBags',
fieldsBagName: 'fieldBags'
}
Vue.use(SocialSharing)
Vue.use(LoadingPlugin, ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(Vuex)
Vue.use(VeeValidate, veeValidateConfig)
Vue.component('toast', Toast)
Vue.component('confirm', Confirm)
Vue.component('x-input', XInput)
Vue.component('group', Group)
Vue.component('icon', Icon)
Vue.component('x-header', CHeader)
FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.prototype.$http = axios

const smartFilter = (value, array, paramName = 'value', isFilterThingVal = false, defaultRes = '') => {
if (!isFilterThingVal && !value) return defaultRes || '-'
for (const item of array) {
if (value === item[paramName]) {
return item.label
}
}
return ''
}

Vue.filter('privacyName', function (value) {
if (!value) return ''
const len = value.length
return value.split('').map((item, index) => {
if (index === 0) return item
else if (index === len - 1 && len !== 2) return item
else return '*'
}).join('')
})

Vue.filter('role', function (value) {
return smartFilter(value, roleList, 'value', false, '一般會員')
})

Vue.filter('shipStatus', (value) => {
return smartFilter(value, stepOptions)
})

Vue.filter('needDonateDealStatus', (value) => {
return smartFilter(value, needDonateDealStatusMap)
})

Vue.filter('shipway', (value) => {
const { way } = shipMapping
if (way[value]) {
return way[value]
} else {
return '-'
}
})

Vue.filter('thingStatus', (value) => {
return smartFilter(value, thingsStatusList)
})

Vue.filter('smartDate', (str) => {
return getSmartDate(str)
})

Vue.filter('distanceDays', (date) => {

const days = 15 - new Elapsed(new Date(dateStandard(date)), new Date()).days.num - 1
return days > 0 ? days : 0
})
Vue.filter('thingValue', (value) => {
return smartFilter(value, valuationList, 'key', true)
})

Vue.filter('smallImage', (path, type) => {
return smartImagePath(path, type)
})

Vue.filter('toCdnBigImage', (path) => {
return smartImagePath(path, false)
})

Vue.filter('gender', (gender) => {
switch (gender) {
case 'MALE':
return '男'

case 'FEMALE':
return '女'

case 'OTHER':
return '其他'

case 'UNKOWN':
return '未知'
}
})

Vue.use(Navigation, {router, store})

sync(store, router)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})
